// Laufzeit-Konfiguration des Frontends.
//
// `dist/` entsteht zur Build-Zeit: Alles aus `process.env.VUE_APP_*` steckt fest im Bundle und
// ist nur durch ein neues Image änderbar. Die wenigen Werte, die je Deployment abweichen, holt
// die App deshalb beim Start aus `config.json` neben dem Bundle. Im Web schreibt der
// nginx-Container diese Datei bei jedem Start aus Umgebungsvariablen
// (`docker-entrypoint.d/40-runtime-config.sh`) — ein Wertwechsel ist damit `.env` plus Neustart.
//
// Der Ladezeitpunkt ist nicht beliebig: Die Basis-URLs in `@/api` sind Modul-Konstanten und
// werden beim ersten Import genau einmal ausgewertet. `main.js` lädt diese Datei deshalb, bevor
// es den Rest der Anwendung dynamisch nachlädt.

/** Zuletzt geladene Konfiguration; leer, solange {@link loadRuntimeConfig} nicht gelaufen ist. */
let loaded = {}

/**
 * Lädt `config.json` neben dem Bundle. Fehlt die Datei oder ist sie unlesbar, bleibt es bei den
 * eingebauten Standardwerten — das ist exakt das Verhalten ohne Laufzeit-Konfiguration und damit
 * auch der Offline-Fall (die Datei wird bewusst nicht vom Service Worker vorgehalten, sonst
 * bliebe eine geänderte Konfiguration bis zum nächsten Worker-Update wirkungslos).
 *
 * @returns {Promise<object>} Die geltende Konfiguration.
 */
export async function loadRuntimeConfig () {
  const url = `${process.env.BASE_URL || '/'}config.json`

  try {
    const response = await fetch(url, { cache: 'no-store' })
    if (!response.ok) return loaded

    const parsed = await response.json()
    if (parsed && typeof parsed === 'object') loaded = parsed
  } catch (error) {
    // Kein Grund, den Start abzubrechen: Ohne Konfiguration gelten die Standardwerte.
    console.warn('[runtimeConfig] config.json nicht geladen, Standardwerte gelten.', error)
  }

  return loaded
}

/**
 * Die geltende Laufzeit-Konfiguration (synchron).
 * @returns {object} Leeres Objekt, solange nichts geladen wurde.
 */
export function runtimeConfig () {
  return loaded
}
